import React, { useEffect, useRef, useState } from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';

interface Props {
  children: string;
  loading: boolean;
  loadingText: string;
  textStyle: StyleProp<TextStyle>;
}

export const INTERVAL_DURATION = 200;

export const LoadingText: React.FC<Props> = ({
  children,
  loading,
  loadingText,
  textStyle,
}) => {
  const [displayText, setDisplayText] = useState<string>(loadingText);

  const tickCount = useRef(0);

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setDisplayText((prev) => {
          if (tickCount.current < 3) {
            tickCount.current = tickCount.current + 1;
            return prev + '.';
          }
          tickCount.current = 0;
          return loadingText;
        });
      }, INTERVAL_DURATION);

      return () => {
        clearInterval(interval);
      };
    } else {
      setDisplayText(loadingText);
    }
  }, [loading, loadingText]);

  return <Text style={textStyle}>{loading ? displayText : children}</Text>;
};
